<template>
    <div>
        <div class="bg" @click="close"></div>
        <div class="praise">
            <img alt="Gut gemacht, den Rest machen wir!" src="/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/praise.png" />
            <p><b>Nach</b> Deiner Bestellung schneiden<br>
                <b>Grafiker</b> Dein Motiv <b>perfekt</b> aus.</p>
            <button
                class="btn is--primary is--center is--large"
                @click="close"
            >Ok, weiter zu Größe & Sockel</button>
        </div>
    </div>
</template>

<script>
    import EventBus from "../event-bus";

    export default {
        methods: {
            close() {
                this.$emit('closePraise');
            },
        }
    }
</script>

<style lang="scss">
@import '../../node_modules/nprogress/nprogress.css';
@import "../assets/scss/utilities/colors";
@import "../assets/scss/components/app";

.praise {
    left: 50%;
    top: 50%;
    width: 400px;
    margin: -235px 0 0 -200px;
    z-index:1000000002;
    text-align: center;
    position: absolute;
    box-sizing: content-box;
    padding: 10px;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 1px 10px rgba(0,0,0,.4);
    -webkit-transition: opacity 0.1s ease-out;
    -moz-transition: opacity 0.1s ease-out;
    -ms-transition: opacity 0.1s ease-out;
    -o-transition: opacity 0.1s ease-out;
    transition: opacity 0.1s ease-out;
    align-items: center;
    button {
        text-align: center;
    }
    @media screen and (max-width: 420px) {
        left: inherit;
        top: inherit;
        margin: inherit;
        max-width: 320px;
    }
}
.bg {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100000001;
    right: 0;
    bottom: 0;
    background-color: rgba(255,255,255,0.6);
}
.is--show {
    visibility: visible;
}
.is--out {
    display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/Praise.vue